export const CHANGE_STATE = "CHANGE_STATE";
export const SET_PAGE = "SET_PAGE";
